import React from 'react';
import { PageSection, HeroSectionContent } from '../../types/page';
import { PropertySearch } from '../property/PropertySearch';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

interface HeroSectionProps {
  section: PageSection;
  className?: string;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ section, className = '' }) => {
  const content = section.content as HeroSectionContent;
  
  if (!content.enabled && content.enabled !== undefined) {
    return null;
  }

  const backgroundStyle = content.backgroundImage 
    ? { backgroundImage: `url(${content.backgroundImage})` }
    : {};

  return (
    <section 
      className={`relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat ${className}`}
      style={backgroundStyle}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            {section.title}
          </h1>
          
          {(section.subtitle || content.subtitle) && (
            <p className="text-xl md:text-2xl mb-8 opacity-90 max-w-2xl mx-auto">
              {section.subtitle || content.subtitle}
            </p>
          )}

          {/* Botones de acción */}
          {(content.primaryButton || content.secondaryButton) && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              {content.primaryButton && (
                <Button 
                  size="lg" 
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3"
                  onClick={() => window.location.href = content.primaryButton!.link}
                >
                  {content.primaryButton.text}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              )}
              
              {content.secondaryButton && (
                <Button 
                  size="lg" 
                  variant="outline"
                  className="border-white text-white hover:bg-white hover:text-black px-8 py-3"
                  onClick={() => window.location.href = content.secondaryButton!.link}
                >
                  {content.secondaryButton.text}
                </Button>
              )}
            </div>
          )}

          {/* Search Component */}
          {content.showSearch && (
            <div className="max-w-4xl mx-auto">
              <PropertySearch />
            </div>
          )}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/60 rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};